import { FC } from "react";

import { DsIcon, DsText } from "../components/ui";
import { openSiteLocationOnMap } from "../utils/site";

type JobSiteLabelPropsType = {
  jobSiteAddress: string;
};

const JobSiteLabel: FC<JobSiteLabelPropsType> = ({ jobSiteAddress }) => {
  const handleOpenSiteLocationOnMap = () => {
    openSiteLocationOnMap(jobSiteAddress);
  };

  return (
    <div
      className="flex items-center hover:cursor-pointer"
      onClick={handleOpenSiteLocationOnMap}>
      <div>
        <DsIcon icon="LocationMarkUnderscored" />
      </div>
      <DsText variant="dataDisplayValue" className="text-[#BD5100] ml-2">
        {jobSiteAddress}
      </DsText>
    </div>
  );
};

export { JobSiteLabel };
